import "./SingleCourse.css"

export default function Course({course_title}){
    return (
        <div className="single-course">
            <div className="course-img">
                -- α --
            </div>
            <div className="course-title">
                {course_title}
            </div>
        </div>
    );
}